/**
 * Location Label Utility
 *
 * Builds a combined venue + address location label from event item fields.
 * Shared between EventCard (blocks panel) and EventPopup (map panel).
 */

import { pickText, buildFullAddress } from '../panels/blocks/cards/shared/fields.js';

/**
 * Builds a combined venue + address location label from event item fields.
 *
 * @param {Object} item - The event item data.
 * @returns {string} Combined location string (e.g. "The Dome • 400 20th St, Virginia Beach").
 */
export function buildLocationLabel(item) {
  const parts = [];
  const venueName = pickText(item, 'venue_name');
  if (venueName) parts.push(venueName);

  const address = buildFullAddress(item);
  if (address) parts.push(address);

  return parts.join(' • ');
}
